import { mapState } from 'vuex'

export default {
  data() {
    return {
      suffixOptions: [
        { value: 'jr', text: 'jr' }
      ],
      stateOptions: [
        { value: 'AL', text: 'Alabama' },
        { value: 'AK', text: 'Alaska' },
        { value: 'AZ', text: 'Arizona' },
        { value: 'AR', text: 'Arkansas' },
        { value: 'CA', text: 'California' },
        { value: 'CO', text: 'Colorado' },
        { value: 'CT', text: 'Connecticut' },
        { value: 'DE', text: 'Delaware' },
        { value: 'FL', text: 'Florida' },
        { value: 'GA', text: 'Georgia' },
        { value: 'HI', text: 'Hawaii' },
        { value: 'ID', text: 'Idaho' },
        { value: 'IL', text: 'Illinois' },
        { value: 'IN', text: 'Indiana' },
        { value: 'IA', text: 'Iowa' },
        { value: 'KS', text: 'Kansas' },
        { value: 'KY', text: 'Kentucky' },
        { value: 'LA', text: 'Louisiana' },
        { value: 'ME', text: 'Maine' },
        { value: 'MD', text: 'Maryland' },
        { value: 'MA', text: 'Massachusetts' },
        { value: 'MI', text: 'Michigan' },
        { value: 'MN', text: 'Minnesota' },
        { value: 'MS', text: 'Mississippi' },
        { value: 'MO', text: 'Missouri' },
        { value: 'MT', text: 'Montana' },
        { value: 'NE', text: 'Nebraska' },
        { value: 'NV', text: 'Nevada' },
        { value: 'NH', text: 'New Hampshire' },
        { value: 'NJ', text: 'New Jersey' },
        { value: 'NM', text: 'New Mexico' },
        { value: 'NY', text: 'New York' },
        { value: 'NC', text: 'North Carolina' },
        { value: 'ND', text: 'North Dakota' },
        { value: 'OH', text: 'Ohio' },
        { value: 'OK', text: 'Oklahoma' },
        { value: 'OR', text: 'Oregon' },
        { value: 'PA', text: 'Pennsylvania' },
        { value: 'RI', text: 'Rhode Island' },
        { value: 'SC', text: 'South Carolina' },
        { value: 'SD', text: 'South Dakota' },
        { value: 'TN', text: 'Tennessee' },
        { value: 'TX', text: 'Texas' },
        { value: 'UT', text: 'Utah' },
        { value: 'VT', text: 'Vermont' },
        { value: 'VA', text: 'Virginia' },
        { value: 'WA', text: 'Washington' },
        { value: 'WV', text: 'West Virginia' },
        { value: 'WI', text: 'Wisconsin' },
        { value: 'WY', text: 'Wyoming' },
        { value: 'DC', text: 'District of Columbia' },
        { value: 'GU', text: 'Guam' },
        { value: 'MH', text: 'Marshall' },
        { value: 'MP', text: 'Northern' },
        { value: 'PW', text: 'Palau' },
        { value: 'PR', text: 'Puerto Rico' },
        { value: 'VI', text: 'Virgin ' }
      ],
      yesNoOptions: [
        { value: 'yes', text: 'Yes' },
        { value: 'no', text: 'No' }
      ],
      addressTypeOptions: [
        { value: 'home', text: 'Home' }
      ],
      accountTypeOptions: [
        { value: 'client', text: 'Client' }
      ],
      phoneTypeOptions: [
        { text: 'Mobile', value: 'mobile' },
        { text: 'Office', value: 'office' },
        { text: 'Other', value: 'other' }
      ]
    }
  },
  methods: {
    optionsResultsMapper(results) {
      if (!Array.isArray(results)) {
        console.warn('results\'s isn\'t array', results)
        return []
      }

      return results.map(result => ({
        value: result.code,
        text: result.description
      }))
    },

    getDisplayValueFromOptionsSet(optionsSetName, value) {
      try {
        let foundOption = this[optionsSetName].find(option => option.value === value)
        return (foundOption ? foundOption.text : '')
      } catch (error) {
        console.error(error)
        return ''
      }
    }
  },
  computed: {
    ...mapState('selectOptionsFromApi', [
      'genders',
      'spokenWrittenLanguages',
      'races',
      'ethnicities',
      'relationships'
    ]),
    genderOptions() {
      return this.optionsResultsMapper(this.genders)
    },
    spokenWrittenlanguageOptions() {
      return this.optionsResultsMapper(this.spokenWrittenLanguages)
    },
    raceOptions() {
      return this.optionsResultsMapper(this.races)
    },
    ethnicityOptions() {
      return this.optionsResultsMapper(this.ethnicities)
    },
    relationshipOptions() {
      return this.optionsResultsMapper(this.relationships)
    }
  },
  created() {
    if (!this.genders || this.genders.length === 0) {
      this.$store.dispatch('selectOptionsFromApi/GET_GENDERS')
    }

    if (!this.spokenWrittenLanguages || this.spokenWrittenLanguages.length === 0) {
      this.$store.dispatch('selectOptionsFromApi/GET_SPOKEN_WRITTEN_LANGUAGES')
    }

    if (!this.races || this.races.length === 0) {
      this.$store.dispatch('selectOptionsFromApi/GET_RACES')
    }

    if (!this.ethnicities || this.ethnicities.length === 0) {
      this.$store.dispatch('selectOptionsFromApi/GET_ETHNICITIES')
    }

    if (!this.relationships || this.relationships.length === 0) {
      this.$store.dispatch('selectOptionsFromApi/GET_RELATIONSHIPS')
    }
  }
}
